import { Plantation, PlantationCreateInput, PlantationListResponse, PlantationResponse, PlantationSelectInput, PlantationUpdateInput } from "@repo/types";
import { AxiosInstance } from 'axios';
import { axiosInstance } from '../axios-instance';
import { ENDPOINTS } from '../endpoint';
import { BaseApiService } from './base-api.service';

export class PlantationService extends BaseApiService {
  constructor(axios: AxiosInstance = axiosInstance) {
    super(ENDPOINTS.PLANTATIONS.BASE, axios);
  }

  async getPlantations(filters: PlantationSelectInput): Promise<PlantationListResponse> {
    const { page = 1, limit = 10, ...rest } = filters;
    return this.getPaginated<Plantation>({ page, limit, ...rest });
  }

  async getPlantationById(id: number): Promise<PlantationResponse> {
    return this.get<PlantationResponse>(`/${id}`);
  }

  async createPlantation(data: PlantationCreateInput): Promise<PlantationResponse> {
    return this.post<PlantationResponse, PlantationCreateInput>('', data);
  }

  async updatePlantation(id: number, data: PlantationUpdateInput): Promise<PlantationResponse> {
    return this.put<PlantationResponse, PlantationUpdateInput>(`/${id}`, data);
  }

  async deletePlantation(id: number): Promise<PlantationResponse> {
    return this.delete<PlantationResponse>(`/${id}`);
  }

  async validatePlantation(id: number, userValidateId: number): Promise<PlantationResponse> {
    return this.put<PlantationResponse>(`/${id}/validate`, { user_validate_id: userValidateId });
  }

  async getPlantationOptions(): Promise<Plantation[]> {
    return this.get<Plantation[]>('/select');
  }

  async getPlantationStatistics(startDate?: string, endDate?: string): Promise<any> {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);

    return this.get(`/statistics${params.toString() ? `?${params.toString()}` : ''}`);
  }
}
